// extracted by mini-css-extract-plugin
module.exports = {"root":"_2ZROG","content":"A9uFL"};